import { PLAN_SECTION_KEY } from '../../../../config'

export const RETAIL_HEADER_KEY = `${PLAN_SECTION_KEY}-retail-header`
